"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  author: 'Author',
  faq: 'FAQ',
  inspirationCorner: 'Inspiration corner',
  otherCategories: 'Other categories',
  photo: 'Photo',
  published: 'Published',
  readLess: 'Read less',
  readMore: 'Read more',
  readNow: 'Read now',
  view: 'View'
};
const translationsNamespace = exports.translationsNamespace = 'products_editorial-page';
